import { defineStore } from "pinia";
import { ref } from "vue";

export const useTokenStore = defineStore(
  "token",
  () => {
    const accessToken = ref<string>("");
    const refreshToken = ref<string>("");

    return {
      accessToken,
      refreshToken,
    };
  },

  {
    persist: true,
  }
);
